'use strict';
// const Loader = require('common/infra/loader');
// const i18n = require('i18next');
const $ = require('jquery');

const ajax = function(method, url, body) {
    let settings = {
        type: method,
        url: url,
        contentType: 'application/json',
        dataType: 'json'
    };

    if(body) {
        settings.data = JSON.stringify(body);
    }

    // Loader.start();
    return new Promise(function(resolve, reject) {
        $.ajax(settings)
            .done(data => {
                resolve(data);
            })
            .fail((jqXHR) => {
                const status = jqXHR.status;

                reject({
                    status: status,
                    jqXHR: jqXHR
                });
            })
            .always(function () {
                // Loader.end();
            });
    });
};

module.exports = {
    GET: function(url) {
        return ajax('GET', url);
    },

    POST: function(url, body) {
        return ajax('POST', url, body);
    },

    PUT: function(url, body) {
        return ajax('PUT', url, body);
    },

    DELETE: function(url) {
        return ajax('DELETE', url);
    }
};



// WEBPACK FOOTER //
// ./jiji/infra/ajax.js